import { render, staticRenderFns } from "./labelNode.vue?vue&type=template&id=6a83d58f&scoped=true"
import script from "./labelNode.vue?vue&type=script&lang=js"
export * from "./labelNode.vue?vue&type=script&lang=js"
import style0 from "./labelNode.vue?vue&type=style&index=0&id=6a83d58f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83d58f",
  null
  
)

export default component.exports